var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup55(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 60,
    viewBox: "0 0 53 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6722 9.92432V14.9411M25.6722 14.9411L31.3549 23.5103V25.9272M25.6722 14.9411H7.20318M21.816 44.1642H1.1145M1.1145 44.1642V25.9272M1.1145 44.1642V46.3614C1.14925 48.9431 2.12928 50.9756 4.97066 50.9756H21.816M1.1145 25.9272H31.3549M1.1145 25.9272V23.5103L7.20318 14.9411M31.3549 25.9272V36.4739L39.4731 51.1953M7.20318 14.9411V9.93057M16.3362 29.8822V40.8684M11.0593 35.3753H21.4101",
    stroke: "#006D77",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.15894,
    y: 1,
    width: 22.3547,
    height: 8.10724,
    rx: 4.05362,
    stroke: "#006D77",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.32162,
    y: 0.338161,
    width: 29.5463,
    height: 15.4359,
    rx: 7.71795,
    transform: "matrix(0.842078 -0.539355 0.479547 0.877516 18.0065 45.454)",
    stroke: "#006D77",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup55);
export default __webpack_public_path__ + "static/media/Group 55.43b72f884e71386a6d91cec366db80f2.svg";
export { ForwardRef as ReactComponent };